<template>
  <not-found v-if="error?.statusCode === 404" />

  <error-listen v-else :error="error"/>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';

defineProps({
  error: {
    type: Object as () => NuxtError,
    default: () => ({ statusCode: 500, message: 'Unknown error' })
  }
})
</script>

<style lang="scss" scoped>

</style>
